import { render, staticRenderFns } from "./AuthenticationWrapper.vue?vue&type=template&id=239c988c&scoped=true&"
import script from "./AuthenticationWrapper.vue?vue&type=script&lang=js&"
export * from "./AuthenticationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c988c",
  null
  
)

export default component.exports